import { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import SelectField from '../../../../FormControl/input/SelectField';

const SelectCurriculumElements = ({ onChangeAlert, currentCurriculum, formData, errors, isPreview }) => {
  const [form, setInputForm] = useState(formData);
  const onChange = (name, value) => {
    let formData = { ...form };

    if (name === 'elementId') {
      formData = { ...form, subElementId: null, [name]: value };
    } else {
      formData = { ...form, [name]: value };
    }
    setInputForm(formData);
    onChangeAlert('curriculumElements', formData);
  };
  useEffect(() => {
    setInputForm(formData);
  }, [currentCurriculum]);

  if (!currentCurriculum || !currentCurriculum?.elements || !currentCurriculum.elementsStructure)
    return <></>;

  const element = currentCurriculum?.elements;
  const elementChildren = element.children.find((item) => item._id === form.elementId?.value);
  const subElement = elementChildren?.elements[0];
  return (
    <>
      <Grid item sm={3}>
        <Typography
          variant='inherit'
          className='font-bold capitalize'
          color='primary'
          align='right'
          component='p'
        >
          {currentCurriculum.elementsStructure?.name}
        </Typography>
      </Grid>
      <Grid item sm={9}>
        {isPreview ? (
          <Typography variant='inherit' component='p'>
            {element?.children?.find((item) => form?.elementId?.value === item._id)?.name}
          </Typography>
        ) : (
          <SelectField
            id={`elementId-${element?.elementStructureId}`}
            name='elementId'
            error={errors.elementId}
            helperText={errors.elementId}
            value={form.elementId?.value || ''}
            onChange={(e) =>
              onChange('elementId', { key: element?.elementStructureId, value: e.target.value })
            }
            options={element.children?.map((item) => ({ value: item._id, label: item.name })) || []}
            placeholder='Choose an option'
          />
        )}
      </Grid>
      {subElement && currentCurriculum.elementsStructure?.children[0] && (
        <>
          <Grid item sm={3}>
            <Typography
              variant='inherit'
              className='font-bold capitalize'
              color='primary'
              align='right'
              component='p'
            >
              {currentCurriculum.elementsStructure?.children[0]?.name}
            </Typography>
          </Grid>
          <Grid item sm={9}>
            {isPreview ? (
              <Typography variant='inherit' component='p'>
                {subElement?.children?.find((item) => form?.subElementId?.value === item._id)?.name}
              </Typography>
            ) : (
              <SelectField
                id={`subElementId-${currentCurriculum.elementsStructure?.children[0]?._id}`}
                name='subElementId'
                error={errors.subElementId}
                helperText={errors.subElementId}
                value={form.subElementId?.value || ''}
                onChange={(e) =>
                  onChange('subElementId', { key: subElement?.elementStructureId, value: e.target.value })
                }
                options={subElement?.children?.map((item) => ({ value: item._id, label: item.name })) || []}
                placeholder='Choose an option'
              />
            )}
          </Grid>
        </>
      )}
    </>
  );
};

export default SelectCurriculumElements;
